import { render, staticRenderFns } from "./inventory-table-header-row.vue?vue&type=template&id=455c6b5c"
import script from "./inventory-table-header-row.vue?vue&type=script&lang=js"
export * from "./inventory-table-header-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports